/**
 * P3-38: ChronoforgeWgt —— 时间锻造面板。
 *
 * 对齐 `js/time.js:1673-1704`：
 * - ShatterTCBtn + UseHeatBtn
 * - chronoforgeUpgrades 列表
 */
import { useGameTick } from "../../bridge/useGameTick";
import type { GamePage } from "../../bridge/GameBridge";
import { SpacePanel } from "../space/SpacePanel";
import ShatterTCBtn from "./ShatterTCBtn";
import TimeUpgradeBtn from "./TimeUpgradeBtn";
import UseHeatBtn from "./UseHeatBtn";

interface ChronoforgeSnapshot {
  visible: boolean;
  upgrades: { name: string }[];
}

function getSnapshot(game: GamePage | null): ChronoforgeSnapshot | null {
  if (!game) {
    return null;
  }
  const visible = game.workshop?.get?.("chronoforge")?.researched ?? false;
  const upgrades = (game.time?.chronoforgeUpgrades ?? []) as { name: string }[];
  return { visible, upgrades };
}

function snapEq(a: ChronoforgeSnapshot | null, b: ChronoforgeSnapshot | null): boolean {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  if (a.visible !== b.visible || a.upgrades.length !== b.upgrades.length) {
    return false;
  }
  for (let i = 0; i < a.upgrades.length; i++) {
    if (a.upgrades[i].name !== b.upgrades[i].name) {
      return false;
    }
  }
  return true;
}

export default function ChronoforgeWgt() {
  const snapshot = useGameTick(
    (game) => getSnapshot(game as GamePage | null),
    snapEq,
  );

  if (!snapshot || !snapshot.visible) {
    return null;
  }

  return (
    <SpacePanel title="workshop.chronoforge.label">
      <div style={{ paddingTop: "20px" }}>
        <ShatterTCBtn />
        <UseHeatBtn />
        {snapshot.upgrades.map((upgrade) => (
          <TimeUpgradeBtn key={upgrade.name} id={upgrade.name} type="chronoforge" />
        ))}
      </div>
    </SpacePanel>
  );
}
